var upload = "https://shopfront-cdn.tekoapis.com/static/c12fdd40ddee1ea3.svg";

export { upload as default };
